import { Phone } from "lucide-react";

const StickyPhone = () => {
  return (
    <a
      href="tel:+16034244608"
      className="fixed bottom-6 right-6 z-40 btn-accent shadow-lg hover:shadow-xl rounded-full p-4 md:px-6 md:py-3 md:rounded-lg"
      aria-label="Call Hill Brothers at 603 424 4608"
    >
      <Phone className="w-6 h-6 md:hidden" aria-hidden="true" />
      <span className="hidden md:flex items-center gap-2">
        <Phone className="w-5 h-5" aria-hidden="true" />
        <span className="font-semibold">603 424 4608</span>
      </span>
    </a>
  );
};

export default StickyPhone;
